
<a @click="onClick">
    <div class="title-info" style="margin-left: 2px">
        <div style="margin-top: -2px" v-if="next">
            <span>nächster ZÜS Termin: </span>
            <span :class="nextOutdated?'outdated error-background':''">{{ next }}</span>
        </div>
        <div style="margin-top: -2px;" v-if="last">Letzte Prüfung: {{ last }}</div>
    </div>
</a>
